import { render, staticRenderFns } from "./IconActionButton.vue?vue&type=template&id=b4e9a9ea"
import script from "./IconActionButton.vue?vue&type=script&lang=js"
export * from "./IconActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports